export default __webpack_public_path__ + "static/media/lock.a01e232b.png";